var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"api-group"},[_c('ux-tooltip',{attrs:{"content":_vm.$t('HT.doubleclick.copy'),"placement":"bottom"}},[_c('span',{staticClass:"api-content",on:{"dblclick":_vm.copyContent}},[_vm._v(_vm._s(_vm.apikey))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }